import { styled } from "@linaria/react";
import Dropzone, { Accept } from "react-dropzone";

import Text, { TextVariant } from "@gx/dls/text/Text";
import { withTheme, type PropsWithTheme } from "@gx/dls/theme";

const DropzoneWrapperDropzoneWrapper = withTheme(styled.div<
  PropsWithTheme<{ $isDragActive: boolean; $isDisabled: boolean }>
>`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 48px;

  width: 100%;

  border: 2px dashed
    ${({ theme, $isDragActive, $isDisabled }) => {
      if ($isDisabled) {
        return theme.color.border.disabled;
      }
      if ($isDragActive) {
        return theme.color.border.primary;
      }
      return theme.color.border.secondary;
    }};
  border-radius: 8px;
  background-color: ${({ theme, $isDragActive, $isDisabled }) => {
    if ($isDisabled) {
      return theme.color.background.disabled;
    }
    if ($isDragActive) {
      return theme.color.background.primary;
    }
    return theme.color.background.tertiary;
  }};

  cursor: ${({ $isDisabled }) => ($isDisabled ? "not-allowed" : "pointer")};

  transition:
    border-color 0.1s ease-in-out,
    background-color 0.1s ease-in-out;

  &:hover {
    border-color: ${({ theme, $isDisabled }) =>
      $isDisabled ? theme.color.border.disabled : theme.color.border.primary};
    background-color: ${({ theme, $isDisabled }) =>
      $isDisabled ? theme.color.background.disabled : theme.color.background.tertiary};
  }
`);

const DropzoneWidgetDropzoneInput = styled.input``;

export interface DropzoneWidgetDropzoneProps {
  onDrop: (acceptedFiles: File[]) => void;
  isDisabled?: boolean;
  accept?: Accept;
}

const DropzoneWidgetDropzone = ({
  onDrop,
  isDisabled = false,
  accept,
}: DropzoneWidgetDropzoneProps) => {
  return (
    <Dropzone onDrop={onDrop} disabled={isDisabled} accept={accept}>
      {({ getRootProps, getInputProps, isDragActive }) => (
        <DropzoneWrapperDropzoneWrapper
          {...getRootProps()}
          $isDragActive={isDragActive}
          $isDisabled={isDisabled}
        >
          <DropzoneWidgetDropzoneInput {...getInputProps()} />
          <Text
            variant={
              isDisabled
                ? TextVariant.DISABLED
                : isDragActive
                  ? TextVariant.PRIMARY
                  : TextVariant.SECONDARY
            }
          >
            Drag and drop files here or click to upload
          </Text>
        </DropzoneWrapperDropzoneWrapper>
      )}
    </Dropzone>
  );
};

export default DropzoneWidgetDropzone;
